import styled from 'styled-components';

export const Label = styled.div`
  margin-bottom: 1.5rem;
  ${props =>
    props.size ? 'display: flex ; width: 48%; flex-direction: column;' : ''}
  strong {
    margin-bottom: 0.8rem;
    color: rgba(255, 255, 255, 0.7);
    display: block;
  }

  span {
    color: #e04a66 !important;
  }
`;
